import { Component } from '@angular/core';
import { ComponentView } from 'src/modules/app-template/models/component-view.model';
import { RestEndpoint } from 'src/modules/sm-base/models/rest-endpoint.model';
import { TableCellType } from 'src/modules/sm-base/models/table-cell-type.enum';
import { TableColumn } from 'src/modules/sm-base/models/table-column.model';
import { TableData } from 'src/modules/sm-base/models/table-data.model';
import { TableRow } from 'src/modules/sm-base/models/table-row.model';
import { TableSortColumn } from 'src/modules/sm-base/models/table-sort-column.model';
import { Utils } from 'src/modules/utils/shared/utils';
import { LearningUserFlat } from '../../shared/learning-user-flat.model';

@Component({
    selector: 'app-edit-learning-users',
    templateUrl: './edit-users.component.html',
    styleUrls: ['./edit-users.component.scss']
})
export class EditUsersComponent extends ComponentView {

    listData: LearningUserFlat[];
    table: TableData;

    async initParams(): Promise<boolean> {
        this.listData = await this.app.loadDataHandler(async () => RestEndpoint.main().find({source: ""}).run("api/lrn/learninguserflat").list(LearningUserFlat), this);

        for (let item of this.listData) {
            (item as any).costCenterString = Utils.arrayItemsToString(item.costCenterNames);
            (item as any).jobDescriptionString = Utils.arrayItemsToString(item.jobDescriptionNames);
        }
        this.table = new TableData([
            new TableColumn("lastName", "Nachname"),
            new TableColumn("firstName", "Vorname"),
            new TableColumn("email", "E-Mail"),
            new TableColumn("costCenterString", "Kostenstellen"),
            new TableColumn("managerFor", "Einrichtungsleitung für"),
            new TableColumn("jobDescriptionString", "Dienstarten"),
            new TableColumn("isAdmin", "Administrator", TableCellType.yesNo),
        //    new TableColumn("mayCreateItems", "Darf Anlegen", TableCellType.yesNo),
            new TableColumn("mayModifyItems", "Darf Lerninhalte bearbeiten", TableCellType.yesNo),
            new TableColumn("mayRunAnalyses", "Darf Auswerten", TableCellType.yesNo)
        ], this.listData.map(o => new TableRow("", o, {
            lastName: o.lastName,
            firstName: o.firstName,
            email: o.email,
            costCenterString: (o as any).costCenterString,
            managerFor: Utils.crop(Utils.arrayItemsToString(o.managerFor), 50, true),
            jobDescriptionString: (o as any).jobDescriptionString,
            isAdmin: o.isAdmin,
         //   mayCreateItems: o.mayCreateItems,
            mayModifyItems: o.mayModifyItems,
            mayRunAnalyses: o.mayRunAnalyses
        })), [new TableSortColumn("lastName"), new TableSortColumn("firstName")]);
        this.app.updateNavigation(null, [
            { label: "Administration", routerLink: ["/enaio-learn", "admin"] },
            { label: "Benutzer", routerLink: ["/enaio-learn", "admin", "users"] }
        ]);
        return true;
    }
}
